<template lang="pug">
	.section-container.section-home.section-loading(style="flex-direction:column;")
		div
			| {{ $t('ui.not_found') }}

		section.section.border-bottom-section
			.section-content
				.columns.is-centered.is-vcentered
					.column
						p.subtitle.has-text-centered
							router-link.button.is-primary(:to="urlHome")
								| {{ $t('button.back_home') }}
</template>

<script>
export default {
	data() {
		return {
			videoPopup: false,
		}
	},
	computed: {
		language() {
			return this.$t('locale.lang')
		},
		urlHome() {
			if (this.$route.params.language) {
				return '/' + this.$route.params.language
			}

			return '/' + this.language
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.home") })
		document.getElementsByTagName("BODY")[0].classList.add('page-header')
	}
}
</script>

<style lang="stylus" scoped>
.section-loading
    min-height 60vh
    display flex
    width 100%
    align-items center
    justify-content center
</style>